import { ICON_TRIANGLE_WARNING, INFO_ICON } from 'app/commons/constants/image.const'
import { useAppSelector } from 'app/store/index'
import { messageErrorAction } from 'app/store/messageError/messageErrorSlice'

import React from 'react'
import { useDispatch } from 'react-redux'

import './style.scss'

const MessageError = () => {
  const dispatch = useDispatch()
  const { messageError, isOpen, optionals }: any = useAppSelector((state) => state.messageError)

  if (isOpen) {
    setTimeout(() => {
      dispatch(messageErrorAction.setInitMessageErrors())
    }, 3000)
  }
  return (
    isOpen && (
      <div className={`MessageError ${optionals?.isWaring ? 'red' : ''}`}>
        <div className="content">
          <div className="icon">
            <img src={optionals?.isWaring ? ICON_TRIANGLE_WARNING : INFO_ICON} alt="Error" width={24} height={24} />
          </div>
          <div className="MessageError-Body">{messageError}</div>
        </div>
      </div>
    )
  )
}

export default MessageError
